import Vue from 'vue';
import storefront from 'lib/storefront';
import * as queries from 'lib/graphql/queries';

export default (el) =>
  new Vue({
    el,
    name: 'BlogAll',
    data() {
      return {
        articles: []
      }
    },
    mounted() {
      this.getBlogs();
    },
    methods: {
      async getBlogs() {
        const response = await storefront.request(queries.getAllBlogs);
        this.articles = response.blogs.edges.map(edge => edge.node.articles.edges.map(article => article.node)).flat();
        console.log(this.articles);
      }
    }
  });
